<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'NotificationSoundSwitch',
})
</script>
<template>
  <div>
    <span class="iconfont" :class="isSound ? 'icon-shengyinkai' : 'icon-shengyinjingyin'" style="font-size: 18px;color: #fff"  @click="toggle"></span>
  </div>
</template>

<script setup name="NotificationSoundSwitch" lang="ts">

import useWebSocket from "@/store/modules/webSocket";
import {asyncComputed} from "@vueuse/core";
const webSocket = useWebSocket();

const isSound = asyncComputed(() => {
  return webSocket.isSound
});
function toggle() {
  isSound.value ? webSocket.disableSound() : webSocket.enableSound();
}
</script>

<style scoped>

</style>